export function buildUnreadUserEventLogQuery(userId) {
    return {
        filters: {
            $and: [
                ...(userId ? [{owner: {id: {$eq: userId}}}] : []),
                {isRead: {$eq: false}},
                {displayType: {$ne: "invisible"}},
            ],
        },
        populate: {
            audit_log: {fields: ["model", "action", "before", "after", "patch"]},
            actor: {populate: {member: {populate: {profileImage: true}}}},
            workspace: {fields: ["name", "documentId"]},
        },
        sort: ["createdAt:desc"],
        pagination: {pageSize: 200},
    };
}
